"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.storeDay1 = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const slice_1 = require("./slices/clusters/slice");
const slice_2 = require("./slices/current-cluster/slice");
const slice_3 = require("./slices/infra-envs/slice");
const slice_4 = require("./slices/feature-flags/slice");
const slice_5 = require("./slices/current-user/slice");
exports.storeDay1 = (0, toolkit_1.configureStore)({
    devTools: {
        name: 'Assisted Installer - Day 1',
    },
    reducer: {
        clusters: slice_1.clustersReducer,
        currentCluster: slice_2.currentClusterReducer,
        infraEnvs: slice_3.infraEnvsReducer,
        featureFlags: slice_4.featureFlagsReducer,
        currentUser: slice_5.currentUserReducer,
    },
});
//# sourceMappingURL=store-day1.js.map